/* eslint-disable */
let icons = [
  {
    id: 'edit',
    label: '编辑区',
    icon: 'edit'
  },
  {
    id: 'tree',
    label: '对象树',
    icon: 'tree'
  },
  {
    id: 'sky',
    label: '天空',
    icon: 'sky'
  },
  {
    id: 'scene',
    label: '场景',
    icon: 'scene',
  },
  {
    id: 'change',
    label: '视图',
    icon: 'change'
  },
  {
    id: 'vr',
    label: 'VR设置',
    icon: 'vr'
  },
  {
    id: 'measure',
    label: '测量',
    icon: 'measure'
  },
  {
    id: 'model',
    label: '创建模型',
    icon: 'model',
  },
  {
    id: 'save',
    label: '保存',
    icon: 'save',
  },
]

export {icons}
